import { apiClient } from 'src/libs/axios';
import { MutationOptions, useMutation, useQueryClient } from '@tanstack/react-query';
import { userKeys } from './user-keys';
import useGetUserAddress from 'src/hooks/useGetUserAddress';
import { Address } from 'viem';

export const cancelWithdrawalTrade = async (id: number) => {
  const response = await apiClient.delete<any>(
    `/api/v2/signatures/withdrawals/${id}`,
    {
      baseURL: process.env.REACT_APP_SIGNATURE_SERVICE_API_ENDPOINT,
    },
  );
  return response.data;
};

export type UseCancelWithdrawalTradeOptions<TError = Error, TContext = unknown> = MutationOptions<
  any,
  TError,
  number,
  TContext
>;

export const useCancelWithdrawalTrade = <TError = Error, TContext = unknown>(
  options?: UseCancelWithdrawalTradeOptions<TError, TContext>,
) => {
  const queryClient = useQueryClient();
  const { address: userAddress } = useGetUserAddress();
  return useMutation({
    mutationFn: cancelWithdrawalTrade,
    onSuccess() {
      return queryClient.invalidateQueries({ queryKey: userKeys.allBalances(userAddress as Address) });
    },
    ...options,
  });
};
